// Theme: nocturne-wave
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'nocturne-wave',
  name: 'NOCTURNE WAVE',
  tagline: 'NOCTURNE WAVE',
  description: 'Onda noturna azul-teal com textura scanline leve.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#080E18', '#0369A1', '#0F1D35', '#BAE6FD'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-nocturne-wave'
  },
  colorVars: {
    '--accent': '#0369A1',
    '--accent-foreground': '#080E18',
    '--background': '#080E18',
    '--border': '#2A4A7A',
    '--card': '#0F1D35',
    '--card-border-active': 'rgba(3, 105, 161, 0.48)',
    '--card-completed': '#0F1D35',
    '--card-foreground': '#BAE6FD',
    '--card-glow': 'rgba(3, 105, 161, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080E18',
    '--foreground': '#BAE6FD',
    '--hold-fill': '#0369A1',
    '--input': '#0F1D35',
    '--modal-bg': '#080E18',
    '--modal-border': '#2A4A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#BAE6FD',
    '--nav-active': '#0369A1',
    '--nav-bg': '#080E18',
    '--popover': '#0F1D35',
    '--popover-foreground': '#BAE6FD',
    '--primary': '#0369A1',
    '--primary-foreground': '#080E18',
    '--ring': '#0369A1',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#BAE6FD',
    '--streak': '#0369A1',
    '--success': '#22C55E',
    '--success-foreground': '#080E18',
    '--xp': '#0369A1',
    '--xp-bg': '#0F1D35'
  },
  resolvedVars: {
    '--accent': '#0369A1',
    '--accent-foreground': '#080E18',
    '--accent-foreground-hsl': '218 50% 6%',
    '--accent-foreground-oklch': 'from #080E18 l c h',
    '--accent-hsl': '201 96% 32%',
    '--accent-oklch': 'from #0369A1 l c h',
    '--background': '#080E18',
    '--background-hsl': '218 50% 6%',
    '--background-oklch': 'from #080E18 l c h',
    '--border': '#2A4A7A',
    '--border-hsl': '216 49% 32%',
    '--border-oklch': 'from #2A4A7A l c h',
    '--border-w': '1px',
    '--card': '#0F1D35',
    '--card-border-active': 'rgba(3, 105, 161, 0.48)',
    '--card-completed': '#0F1D35',
    '--card-completed-hsl': '218 56% 13%',
    '--card-completed-oklch': 'from #0F1D35 l c h',
    '--card-foreground': '#BAE6FD',
    '--card-foreground-hsl': '201 94% 86%',
    '--card-foreground-oklch': 'from #BAE6FD l c h',
    '--card-glow': 'rgba(3, 105, 161, 0.1)',
    '--card-hsl': '218 56% 13%',
    '--card-oklch': 'from #0F1D35 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080E18',
    '--destructive-foreground-hsl': '218 50% 6%',
    '--destructive-foreground-oklch': 'from #080E18 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#BAE6FD',
    '--foreground-hsl': '201 94% 86%',
    '--foreground-oklch': 'from #BAE6FD l c h',
    '--hold-fill': '#0369A1',
    '--hold-fill-hsl': '201 96% 32%',
    '--hold-fill-oklch': 'from #0369A1 l c h',
    '--input': '#0F1D35',
    '--input-hsl': '218 56% 13%',
    '--input-oklch': 'from #0F1D35 l c h',
    '--modal-bg': '#080E18',
    '--modal-bg-hsl': '218 50% 6%',
    '--modal-bg-oklch': 'from #080E18 l c h',
    '--modal-border': '#2A4A7A',
    '--modal-border-hsl': '216 49% 32%',
    '--modal-border-oklch': 'from #2A4A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#BAE6FD',
    '--muted-foreground-hsl': '201 94% 86%',
    '--muted-foreground-oklch': 'from #BAE6FD l c h',
    '--muted-hsl': '216 49% 32%',
    '--muted-oklch': 'from #2A4A7A l c h',
    '--nav-active': '#0369A1',
    '--nav-active-hsl': '201 96% 32%',
    '--nav-active-oklch': 'from #0369A1 l c h',
    '--nav-bg': '#080E18',
    '--nav-bg-hsl': '218 50% 6%',
    '--nav-bg-oklch': 'from #080E18 l c h',
    '--popover': '#0F1D35',
    '--popover-foreground': '#BAE6FD',
    '--popover-foreground-hsl': '201 94% 86%',
    '--popover-foreground-oklch': 'from #BAE6FD l c h',
    '--popover-hsl': '218 56% 13%',
    '--popover-oklch': 'from #0F1D35 l c h',
    '--primary': '#0369A1',
    '--primary-foreground': '#080E18',
    '--primary-foreground-hsl': '218 50% 6%',
    '--primary-foreground-oklch': 'from #080E18 l c h',
    '--primary-hsl': '201 96% 32%',
    '--primary-oklch': 'from #0369A1 l c h',
    '--radius': '12px',
    '--ring': '#0369A1',
    '--ring-hsl': '201 96% 32%',
    '--ring-oklch': 'from #0369A1 l c h',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#BAE6FD',
    '--secondary-foreground-hsl': '201 94% 86%',
    '--secondary-foreground-oklch': 'from #BAE6FD l c h',
    '--secondary-hsl': '216 49% 32%',
    '--secondary-oklch': 'from #2A4A7A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#0369A1',
    '--streak-hsl': '201 96% 32%',
    '--streak-oklch': 'from #0369A1 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#080E18',
    '--success-foreground-hsl': '218 50% 6%',
    '--success-foreground-oklch': 'from #080E18 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(201 96% 32% / 0.15)',
    '--xp': '#0369A1',
    '--xp-bg': '#0F1D35',
    '--xp-bg-hsl': '218 56% 13%',
    '--xp-bg-oklch': 'from #0F1D35 l c h',
    '--xp-hsl': '201 96% 32%',
    '--xp-oklch': 'from #0369A1 l c h'
  }
}
